import React from 'react'
import styled from 'styled-components'

import { legalAgreementIds } from '../../../../../utils/legalAgreements'
import { ClickWrapContentComponent } from '../../../clickwrap/types'
import * as Styled from '../styled'

const PLAgreementOct022023Content: ClickWrapContentComponent<{ className?: string }> = ({
  className,
}) => {
  return (
    <Styled.ContentContainer className={className}>
      <h1>Private Label Agreement</h1>
      <p>
        THIS AGREEMENT (DEFINED BELOW) TAKES EFFECT WHEN YOU CLICK THE “I AGREE” BUTTON BELOW (“
        <strong>EFFECTIVE DATE</strong>”). EXCEPT TO THE EXTENT OTHERWISE PROVIDED BELOW IN SECTION
        11, BY CLICKING ON THE “I AGREE” BUTTON AT THE BOTTOM OF THIS AGREEMENT, YOU: (A)
        ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND THIS AGREEMENT; (B) REPRESENT AND WARRANT THAT
        YOU ENTER INTO THIS AGREEMENT ON BEHALF OF YOURSELF IN YOUR INDIVIDUAL CAPACITY AS A NATURAL
        PERSON, AND NOT AS A BUSINESS ENTITY OR ON BEHALF OF A BUSINESS ENTITY; (C) REPRESENT AND
        WARRANT THAT YOU, AS A NATURAL PERSON, AND NOT AS A BUSINESS ENTITY OR ON BEHALF OF A
        BUSINESS ENTITY, ARE THE PRIVATE LABEL ACCOUNT HOLDER; AND (C) ACCEPT THIS AGREEMENT AND
        AGREE THAT YOU ARE LEGALLY BOUND BY ITS TERMS.
      </p>
      <p>
        IF YOU DO NOT ACCEPT THESE TERMS, YOU MAY NOT ESTABLISH A PRIVATE LABEL ACCOUNT TO PURCHASE
        PRODUCTS (DEFINED BELOW).
      </p>
      <p>
        1. <span className="text-underline">Applicability; Scope.</span> This Private Label
        Agreement incorporates by reference the Terms of Sale – Wholesale Accounts (“Terms of
        Sale”), available at{' '}
        <a href="https://www.designsforhealth.com/terms-of-sale-wholesale-accounts">
          https://www.designsforhealth.com/terms-of-sale-wholesale-accounts
        </a>{' '}
        or such other URL as DFH (defined below) may designate from time to time. For the avoidance
        of doubt, this Private Label Agreement is an “Underlying Agreement” as defined in the Terms
        of Sale. The term “Agreement”: (i) as used in this Private Label Agreement, means the
        combination of this Private Label Agreement and the Terms of Sale, excluding all Other
        Agreements (as defined in the Terms of Sale); and (ii) as used in the Terms of Sale, means
        the combination of the Terms of Sale, this Private Label Agreement, and all Other
        Agreements. This Private Label Agreement shall prevail over the Terms of Sale to the extent
        the two documents conflict with one another, in both cases where this Private Label
        Agreement is expressly identified as superseding the Terms of Sale and where not expressly
        identified but so conflicting.
      </p>
      <p>
        2. <span className="text-underline">Parties.</span> This Agreement is between Customer and
        the following entity (“DFH”): (i) Designs for Health Ltd. if Customer’s Orders (defined in
        the Terms of Sale) provide for a Delivery Address (defined in the Terms of Sale) within
        Canada; or (ii) Designs for Health, Inc., in all other situations. Customer and DFH are each
        a “Party,” and both are the “Parties.” If some of Customer’s Orders provide for a Delivery
        address within Canada, and some do not, then this Agreement constitutes two separate
        agreements—an agreement between Customer and Designs for Health Ltd. pursuant to subpart (i)
        of the foregoing sentence, and an otherwise identical agreement between Customer and Designs
        for Health Ltd. pursuant to subpart (ii). For the avoidance of doubt, this Section 2
        supersedes any conflicting identification of the Parties in the Terms of Sale.
      </p>
      <p>
        3. <span className="text-underline">Private Label Program.</span>
      </p>
      <p>
        A. <span className="text-italic">Private Label Products</span>. DFH agrees to supply certain{' '}
        <span className="text-italic">Designs for Health®</span> branded products (“
        <strong>DFH Products</strong>”) and/or custom products of Customer as private label products
        under Customer’s brand and to create an <strong>Account</strong> (defined in the Terms of
        Sale) through which Customer may purchase such products and manage Customer’s relationship
        with DFH (“<strong>Private Label Account</strong>”), in each case under the terms and
        conditions of this Agreement. The Parties may also agree that DFH will supply{' '}
        <span className="text-italic">Designs for Sport</span>® branded products (“
        <strong>DFS Products</strong>”) to Customer. DFH will determine in its sole discretion what
        DFS Products, DFH Products, and other products from its line are available to private label
        customers. DFH Products, DFS Products, and all other products that DFH supplies as private
        label products under Customer’s brand shall be referred to in this Agreement as “
        <strong>Products</strong>.”
      </p>
      <p>
        B. <span className="text-italic">Territory</span>. Customer may sell, deliver, or cause to
        be sold or delivered, Products to any location worldwide, subject to applicable export
        restrictions as provided in the Terms of Sale. Definitions relevant to the geographic area
        of Customer’s Product sales are below.
      </p>
      <p className="text-indent">
        <p>
          (1) <span className="text-italic">U.S. Products.</span> “<strong>U.S. Products</strong>”
          means Products that Customer sells, delivers, or causes to sold or delivered, to any
          location, entity, or person in the United States of America (“<strong>U.S.</strong>”), and
          Products that DFH or DFH’s <strong>Affiliates</strong> ( defined in the Terms of Sale)
          deliver, or cause to be delivered, to Customer or Customer’s customers at a U.S. address.
        </p>
        <p>
          (2) <span className="text-italic">Canadian Products</span>. “
          <strong>Canadian Products</strong>” means Products that Customer sells, delivers, or
          causes to be sold or delivered, to any location, entity, or person in Canada, and Products
          that DFH or DFH’s Affiliates deliver, or cause to be delivered, to Customer or Customer’s
          customers at a Canadian address.
        </p>
        <p>
          (3) <span className="text-italic">International Products</span>. “
          <strong>International Products</strong>” means all Products other than U.S. Products and
          Canadian Products.
        </p>
        <p>
          (4) <span className="text-italic">Foreign Territory</span>. “
          <strong>Foreign Territory</strong>” means any location outside the U.S. and Canada.
        </p>
        <p>
          (5) <span className="text-italic">Territory</span>. “<strong>Territory</strong>” means:
          (1) the U.S. as to U.S. Products; (2) Canada as to Canadian Products; and (3) Foreign
          Territories, as to International Products.
        </p>
      </p>
      <p>
        C. <span className="text-italic">Labeling and Product Setup</span>.
      </p>
      <p className="text-indent">
        (1) <span className="text-italic">Labeling Requirements for All Products.</span>
        <p className="text-indent">
          <p>
            (a) <span className="text-italic">Label Design, Generally.</span> Customer, in
            Customer’s reasonable discretion, shall direct DFH as to the content and appearance of
            Product labels in all respects, which DFH shall print and affix to the Products, except
            that DFH pursuant to Section 3.C.(2).(a) shall provide the Regulated Copy (defined below
            in that Section) printed on U.S. and Canadian Product labels. Customer is not authorized
            to print or affix Product labels.
          </p>
          <p>
            (b) <span className="text-italic">Label Design Process, Fees.</span> Fees for the setup
            or revision of each Product label design template apply in all cases, even if Customer
            uses its own graphic designer, and will be billed in accordance with DFH’s standard rate
            sheet for graphic design and set up services (the “<strong>Rate Sheet</strong>”). If DFH
            provides permission for Customer to use its own graphic designer to prepare Product
            labels, and DFH provides label artwork files to Customer, then Customer shall use the
            files only for the purpose of designing such labels for Products and for no other
            purpose. Fees for Customer label graphic design work above and beyond the basic setup or
            revision work and an additional hourly fee for any revisions or edits made to Product
            labels after Customer approval will be billed in accordance with the Rate Sheet. The
            Parties will follow the process set forth in{' '}
            <u>Schedule B: Private Label Setup Process</u>, as may be updated by DFH from time to
            time in its sole discretion.
          </p>
          <p>
            (c) <span className="text-italic">No Reference to “Designs for Health,” Etc.</span>{' '}
            Customer shall not use or make any reference to “Designs for Health” or any Designs for
            Health-branded products or product names on the packaging or labels for any Product, as
            keywords for online searches, or in any mobile applications, advertising, product
            listing or any other communications or Marketing Materials. Notwithstanding the
            foregoing, DFH may be identified as the product license holder or importer of Canadian
            Products in Regulated Copy to the extent required by applicable
            <strong>Law</strong> (defined in the Terms of Sale).
          </p>
          <p>
            (d) <span className="text-italic">Adverse Events; Product Inquiries/Complaints.</span>{' '}
            Customer shall provide DFH with a phone number for the Product labels where users of the
            Products may report adverse events or make Product inquiries or complaints. Customer
            shall promptly report to DFH, by calling DFH Customer Service at 1-860-623-6314, each
            adverse event or complaint about a Product or its use of which Customer becomes aware.
            Customer shall immediately report any such serious adverse event to DFH so DFH may
            comply with applicable Food & Drug Administration (“
            <strong>FDA</strong>”) regulations and other regulations, as applicable, concerning
            investigation and reporting of such serious adverse events. Customer agrees to cooperate
            and provide reasonable assistance to DFH in the investigation of any adverse event or
            complaint. Notwithstanding the foregoing, Customer shall handle all Product inquiries
            and complaints from persons in Foreign Territories, and Customer shall comply with all
            adverse event reporting requirements in Foreign Territories.
          </p>
          <p>
            (e) <span className="text-italic">Product Changes.</span> DFH, at any time in its sole
            discretion, reserves the right to discontinue the availability of any Products or to
            change their formulas, routes of administration, or any other such details in DFH’s
            absolute discretion. Customer is not entitled to be notified of such changes, except to
            the extent the Regulated Copy (defined below in Section 3.C.(2).(a)) on the labels of
            affected Products delivered to Customer will reflect such changes if required by
            applicable Law.
          </p>
        </p>
      </p>
      <p className="text-indent">
        (2) <span className="text-italic">Labeling Requirements for US and Canadian Products.</span>
        <p className="text-indent">
          <p>
            (a) <span className="text-italic">Regulated Copy</span>. DFH shall provide Customer with
            the following (“
            <strong>Regulated Copy</strong>”): (ii) on U.S. Product labels, the elements required by
            the applicable FDA regulations, which are the statement of identity, statement of net
            weight/contents, Supplement Facts or Nutrition Facts, ingredient statement, and allergen
            statement; and (ii) on Canadian Product labels, the elements required by the Consumer
            Packaging and Labeling Act of Canada and the Natural and Non-Prescription Health
            Products Directorate. Customer shall use Regulated Copy for such labels in unaltered
            form.
          </p>
          <p>
            (b) <span className="text-italic">“Distributed By” Statement</span>. Promptly upon or
            after the Effective Date, and in no event later than when directed to do so by DFH in
            its absolute discretion, Customer shall provide, for all U.S. and Canadian Product
            labels respectively: (i) a “distributed by” statement as required by the FDA and
            applicable U.S. Laws, and (ii) a domicile statement as required by Health Canada and
            applicable Canadian Laws (each a “<strong>‘Distributed By’ Statement</strong>”
            regardless of Territory). If Customer in DFH’s absolute discretion fails to do so, then
            DFH reserves the right to use, for such “Distributed By” Statement, any name(s) and/or
            street address(es) that Customer provided when creating Customer’s Private Label Account
            or any other Account with DFH. Customer may direct DFH to revise the “Distributed By”
            Statement on Product labels to the extent such directive is received by DFH in writing
            before DFH has begun the process of manufacturing any Products affected by the
            directive.
          </p>
          <p>
            (c) <span className="text-italic">Marketing Copy & Materials</span>. Customer shall
            provide to DFH all Marketing Copy (defined below) for US and Canadian Product labels.
            DFH may recommend Marketing Copy or Customer may source Marketing Copy from DFH, but
            regardless of whether DFH provides review or feedback on Marketing Copy, Customer
            remains solely responsible for ensuring that Marketing Copy and its business practices,
            website, mobile applications, advertising and other marketing materials (collectively, “
            <strong>Marketing Materials</strong>”) comply with all applicable Laws including without
            limitation, as to Canadian Products, the Consumer Packaging and Products Directorate.
            Customer agrees to seek the advice of qualified legal counsel to confirm the compliance
            of Marketing Copy and Marketing Materials with Laws and regulations applicable to the
            labeling and sale of the Products. “<strong>Marketing Copy</strong>” means all text and
            images on the Product label that are not Regulated Copy, including without limitation
            Customer’s private label brand name, Product names, other Trademarks (defined below in
            Section 3.C.(6).(a)), taglines, product claims, use or intake instructions, and, for
            U.S. Products, <strong>Prop 65 Warnings</strong> (defined in the Terms of Sale).
          </p>
        </p>
      </p>
      <p className="text-indent">
        (3) <span className="text-italic">Labeling Requirements for U.S. Products</span>
        <p className="text-indent">
          (a) <span className="text-italic">Prop 65.</span> For the avoidance of doubt, the
          provisions in the Terms of Sale regarding California’s <strong>Prop 65</strong> (defined
          therein) apply to this Agreement, and Customer shall ensure compliance with Prop 65 as set
          forth in this Agreement.
        </p>
      </p>
      <p className="text-indent">
        (4) <span className="text-italic">Labeling Requirements for Canadian Products.</span>
        <p className="text-indent">
          <p>
            (a) <span className="text-italic">Product Registration with Health Canada</span>. In the
            event DFH determines that a Product requires a natural health product license (“
            <strong>NHP License</strong>”) from Health Canada for lawful import, sale or
            distribution in Canada, such Product is an “<strong>NHP Product</strong>”. DFH shall
            apply to Health Canada to update its existing NHP Licenses to add the NHP Products. If
            DFH applies to Health Canada to update the NHP License for any DFH product, due to
            reformulation or otherwise, then DFH’s standard procedure is to include the
            corresponding NHP Product in the application. All product names are subject to approval
            by Health Canada. Any submission, to Health Canada, of Customer’s Product names shall be
            done at DFH’s reasonable convenience, and DFH shall not be liable for the effects of any
            untimeliness or disapproval on the part of Health Canada. Order lead times for Canadian
            Products do not include time required to obtain or update an NHP License.
          </p>
          <p>
            (b) <span className="text-italic">Notification of Material Product Changes.</span> If a
            reformulation or other change described above in Section 3.C.(4).(a). to a Canadian
            Product is material, then DFH as a courtesy intends, but is not required, to notify
            Customer of the change (including by email). For purposes of this Section 3.C.(4).(b), a
            “material” Product change refers only to: (i) a material change to the quantity of
            medical ingredient per dosage unit; (ii) the addition or substitution of medical
            ingredients; (iii) a change in the dosage form; or (iv) a change to the route of
            administration.
          </p>
          <p>
            (c) <span className="text-italic">Rejection due to Improper Registration</span>. Orders
            for Canadian Products without a valid NHP License are deemed rejected as to such
            Canadian Products until DFH advises Customer in writing (including by email) that a
            valid NHP License is available for such Products. Orders for International Products
            without a valid product registration in the Territory are deemed rejected as to such
            Products until Customer provides written notice to DFH that the Products are lawfully
            registered.
          </p>
        </p>
      </p>
      <p className="text-indent">
        (5) <span className="text-italic">Labeling Requirements for International Products.</span>
        <p className="text-indent">
          <p>
            (a){' '}
            <span className="text-italic">
              Customer Solely Responsible for Legal Compliance of International Products
            </span>
            . Both Parties agree and acknowledge that as of the Effective Date, DFH and DFH’s
            Affiliates: (i) have no physical presence in any Foreign Territory; (ii) do not market
            or sell goods or services to end users in any Foreign Territory; and (iii) do not
            undertake to educate themselves about the Laws applicable to Customer’s business
            operations in any Foreign Territory. Accordingly, Customer, and not DFH, is solely
            responsible for compliance with all Laws of, or applicable in, Foreign Territories (“
            <strong>Foreign Laws</strong>”), including, without limitation, Laws regarding labeling,
            ingredient permissibility, and Product registration requirements. For the avoidance of
            doubt, the scope of such responsibility includes, without limitation: (i) International
            Products; (ii) their importation into, and sales within and among, Foreign Territories;
            and (iii) each Party’s business operations and other acts or omissions arising from or
            related to this Agreement. DFH HEREBY DISCLAIMS ALL LIABILITY WHATSOEVER ARISING FROM OR
            RELATED TO NONCOMPLIANCE WITH FOREIGN LAWS, INCLUDING, WITHOUT LIMITATION, LAWS
            REGARDING LABELING, INGREDIENT PERMISSIBILITY, AND PRODUCT REGISTRATION REQUIREMENTS.
            Any suggestions or assistance DFH may provide to Customer regarding Product labeling or
            Product formulation is for marketing and not legal purposes.
          </p>
          <p>
            (b) <span className="text-italic">Registration of International Products</span>.
            Customer is solely responsible for registering International Products in Foreign
            Territories (if required by Law) and for compliance of such Products, their ingredients
            and labeling with local Laws and regulations in the Foreign Territory. Customer shall
            provide DFH with all information necessary for DFH to apply to the FDA or relevant state
            authority for free sale certificates (where applicable), which enable export of the
            International Products from the U.S. However, DFH reserves the right not to apply for
            free sale certificates in its sole and absolute discretion. To the extent DFH chooses to
            apply for free sale certificates under this Section 3.(C).(5).(b), DFH is solely
            responsible for applying for such free sale certificates and Customer agrees not to
            apply or cause any of its agents or representatives to apply for a free sale certificate
            from the FDA. Customer shall reimburse DFH upon written notice (including by email) for
            fees and direct costs associated with free sale certificate applications for
            International Products.
          </p>
        </p>
      </p>
      <p className="text-indent">
        (6) <span className="text-italic">Trademarks.</span>
        <p className="text-indent">
          <p>
            (a) <span className="text-italic">“Trademarks” and “DFH Trademarks” Defined</span>. “
            <strong>Trademarks</strong>” means all rights in and to U.S. and foreign trademarks,
            service marks, trade dress, trade names, brand names, logos, names, images, corporate
            names and internet domain names, whether registered or unregistered. “
            <strong>DFH Trademarks</strong>” means Trademarks owned by DFH or DFH’s Affiliates.
          </p>
          <p className="text-indent">
            <p>
              (i){' '}
              <span className="text-italic">
                Use of Designs for Sport® Trademark Required on DFS Product Labels
              </span>
              . Each DFS Product label will include in a prominent position the DFH Trademark “
              <span className="text-italic">Powered by Designs for Sport</span>” or a similar
              tagline or statement to be determined by DFH in its sole discretion. In addition, each
              DFS Product label will include the following Trademark attribution statement, “
              <span className="text-italic">Designs for Sport</span>® is a registered trademark of
              Designs for Health, Inc. Used with permission.” During the Term and for six (6) months
              thereafter solely in connection with selling through existing inventory of DFS
              Products bearing the <span className="text-italic">Designs for Sport</span> Trademark
              on the label, DFH hereby grants to Customer a nonexclusive royalty-free right and
              license to use the <span className="text-italic">Designs for Sport</span> Trademark on
              DFS Product labels in accordance with this Agreement.
            </p>
            <p>
              (ii){' '}
              <span className="text-italic">No Other Use of DFH Trademarks Without Permission</span>
              . Except as expressly set forth above in Sections 3.C.(1).(c) and 3.C.(6).(a).(i), no
              license to use any DFH Trademark, including{' '}
              <span className="text-italic">Designs for Sport</span>®, is provided under this
              Agreement. Customer shall obtain DFH’s prior written approval before using{' '}
              <span className="text-italic">Designs for Sport</span> or any other DFH Trademark in
              any Marketing Materials or otherwise, and Customer shall comply with any terms and
              conditions provided by DFH related to Customer’s use of any such DFH Trademarks
              authorized hereunder.
            </p>
          </p>
          <p>
            (b) <span className="text-italic">Trademark-related Prohibitions</span>. Customer shall
            not: (i) use any Trademark anywhere that is confusingly similar to a DFH Trademark as
            reasonably determined by DFH; (ii) register or apply for registrations anywhere in the
            world for a DFH Trademark or any other Trademark that, in the sole opinion of DFH, is
            confusingly similar to a DFH Trademark or that incorporates a DFH Trademark in whole or
            in part; (iii) engage in any action or make any statement that tends to disparage,
            dilute the value of, or otherwise reflect negatively on the Products, DFH products, DFH
            or any DFH Trademark; or (iv) challenge any right, title or interest of DFH in or to
            Non-Customer Intellectual Property (defined in the Section below in Section 7) or take
            any action that may interfere with any of DFH’s rights in or to Non-Customer
            Intellectual Property or DFH’s exercise thereof. In the event Customer registers or
            applies to register any Trademark in violation of sub section (ii) of this paragraph,
            Customer shall immediately abandon any such registration or application or, upon DFH’s
            written demand, assign it to DFH at Customer’s expense. Customer shall reimburse DFH for
            all the costs and expenses incurred by DFH in furtherance of any opposition,
            cancellation, or related legal proceeding, including without limitation attorneys’ fees,
            in connection with any such registration or application.
          </p>
          <p>
            (c) <span className="text-italic">Third-Party Trademarks</span>. DFH is subject to
            various Trademark licenses of third-party proprietary ingredient suppliers and DFH may
            make, but is not required to make, such third- party Trademarks available for use by
            Customer on Product labels. DFH may remove such third- party Trademarks from Product
            labels at any time in its sole discretion. In the event DFH agrees to include such
            third-party Trademarks on Product labels, Customer shall not alter or modify such
            trademarks or related Trademark label statements. Customer is not authorized to use any
            third-party Trademarks included on Product labels in any other non-label marketing
            materials without the prior written consent of DFH.
          </p>
        </p>
      </p>
      <p>
        4. <span className="text-underline">Product Sales.</span>
      </p>
      <p>
        A. <span className="text-italic">Prices and Ordering</span>.
        <p className="text-indent">
          <p>
            (1) <span className="text-italic">Prices to Customer.</span> Prices for sales of U.S.,
            Canadian, and International Products from DFH to Customer shall each be as set forth,
            respectively, on the U.S., Canadian, and International Private Label Wholesale Price
            Lists for <span className="text-italic">Designs for Health®</span> or
            <span className="text-italic">Designs for Sport</span>® branded Products, as
            applicable, and as they may be modified and distributed by DFH from time to time in its
            sole discretion (each such price list, as applicable, the “<strong>Price List</strong>
            ”), subject to shipping and handling charges applicable to DFH’s private label
            customers. No discounts, rebates, or other pricing incentives apply unless agreed to in
            a writing signed by an authorized representative of DFH. Unless otherwise indicated: (i)
            all prices of Canadian Products are in Canadian Dollars, and (ii) all prices of U.S. and
            International Products are in U.S. Dollars. All prices are subject to change by DFH in
            its sole discretion upon written notice to Customer. Except as may be otherwise
            indicated during <strong>Checkout</strong>
            (defined in the Terms of Sale): (i) all Product prices, including without limitation the
            prices printed in the Price List, are exclusive of all sales, use and excise taxes, and
            any other similar taxes, duties and charges of any kind imposed by any governmental
            authority on any amounts payable by Customer; and (ii) Customer shall be responsible for
            all such charges, costs and taxes, except taxes on DFH’s income, revenues, gross
            receipts, personnel or real or personal property or other assets.
          </p>
          <p>
            (2) <span className="text-italic">Deposit.</span> For the avoidance of doubt, except as
            may be otherwise provided by a separate <strong>Credit Agreement</strong>
            (defined in the Terms of Sale) between the Parties, DFH at any time reserves the right
            to reject or cancel any Order unless Customer pays a deposit in an amount determined by
            DFH, which right DFH may exercise in its absolute discretion.
          </p>
          <p>
            (3) <span className="text-italic">Prices to Customer’s customers.</span> Resale pricing
            for the Products is in the sole discretion of Customer, except that Customer shall not
            list, offer for sale, or sell the Products on any Third-Party E-Commerce Platform
            (defined below) at a resale price that is below DFH’s suggested online retail price for
            private label products, as set forth on the Price List or as otherwise communicated by
            DFH to Customer in writing. “<strong>Third-Party E-Commerce Platform</strong>” means any
            website or mobile application that is not owned or operated exclusively by or on behalf
            of Customer.
          </p>
          <p>
            (4) <span className="text-italic">Lapse</span>. If DFH does not accept an Order within
            seven (7) days of DFH’s receipt of the Order, the Order will lapse.
          </p>
        </p>
      </p>
      <p>
        5. <span className="text-underline">Term, Termination, Suspension.</span>
      </p>
      <p>
        A. <span className="text-italic">Term</span>. The term of this Agreement shall begin on the
        Effective Date and continue until terminated by either Party in accordance with this Section
        5.
      </p>
      <p>
        B. <span className="text-italic">Termination for Any Reason</span>. Either Party may
        terminate this Agreement for any reason upon thirty (30) days’ prior written notice to the
        other Party (“
        <strong>Termination for Convenience</strong>”).
      </p>
      <p>
        C. <span className="text-italic">Termination for Cause</span>. In addition to any remedies
        that may be provided in this Agreement, at law or in equity, DFH may terminate this
        Agreement with immediate effect (“
        <strong>Termination for Cause</strong>”) upon written notice to Customer, if Customer: (i)
        fails to pay any amount when due under this Agreement and such failure continues for ten
        (10) days after Customer’s receipt of written notice of nonpayment; (ii) has not otherwise
        performed or complied with any of the terms of this Agreement, in whole or in part, and has
        not cured such non-performance or non-compliance within thirty (30) days of written notice
        from DFH; or (iii) becomes insolvent, files a petition for bankruptcy or commences or has
        commenced against it proceedings relating to bankruptcy, receivership, reorganization or
        assignment for the benefit of creditors.
      </p>
      <p>
        D. <span className="text-italic">Events Upon Termination</span>.
      </p>
      <p className="text-indent">
        <p>
          (1) <span className="text-italic">Final Open Orders upon Termination</span>. For so long
          as, and to the extent that, any Orders, as of the date a notice of termination is
          received, remain open in whole or in part and were properly sent to, and accepted by, DFH,
          they shall be referred to in this Agreement as “<strong>Final Open Orders</strong>” or “
          <strong>FPOs</strong>.”
        </p>
        <p className="text-indent">
          <p>
            (a) <span className="text-italic">FPOs upon Termination for Convenience</span>. After
            Termination for Convenience, DFH shall fulfill all FPOs except for blanket purchase
            orders (“<strong>BPOs</strong>”). For the avoidance of doubt, BPOs are governed by
            Section 5.D.(1).(b) below regardless of the nature of the termination.
          </p>
          <p>
            (b) <span className="text-italic">FPOs upon Termination for Cause, and BPOs</span>.
            After Termination for Cause, and with respect to any BPOs that, after termination of any
            kind, are FPOs, DFH in its absolute discretion may: (i) fulfill the FPOs; (ii) cancel
            them; or (iii) condition their fulfillment upon any act, omission, or status of Customer
            or a third party, including without limitation the advancement by or on behalf of
            Customer of payment in full for the Ordered Products or for any raw materials DFH may
            have ordered, or may intend to order, for the manufacturing thereof.
          </p>
        </p>
        <p>
          (2) <span className="text-italic">Other Effects of Termination:</span> Upon termination:
          (i) DFH shall immediately cease performing any services hereunder, except to the extent
          DFH fulfills FPOs pursuant to Section 5.D.(1) above; (ii) All amounts owed to DFH, if any,
          shall immediately become due and payable, notwithstanding any payment terms or due dates
          to the contrary to which the Parties may have agreed; (iii) DFH shall ship to Customer, at
          Customer’s expense, any Products remaining in DFH’s inventory that have been paid for in
          full by Customer, except to the extent any other payables from Customer are due and
          outstanding.
        </p>
        <p>
          (3) <span className="text-italic">No Effect on Other Agreements.</span> For the avoidance
          of doubt, termination of this Agreement by either Party will not affect any Other
          Agreement, and if any Other Agreement remains in effect after such termination, then the
          Terms of Sale shall continue to bind the Parties insofar as they are incorporated into
          such Other Agreement.
        </p>
      </p>
      <p>
        E. <span className="text-italic">Suspension</span>. In addition to any remedies that may be
        provided in this Agreement, at law or in equity, if Customer breaches this Agreement or
        exhibits a pattern of breaches or other behavior that reasonably suggests that Customer’s
        compliance with this Agreement is not reliable, then DFH reserves the right not to accept
        Orders until such time as the breach is fully cured and DFH reasonably believes such
        breaches will not recur.
      </p>
      <p>
        6. <span className="text-underline">Confidential Information</span>. All non-public,
        confidential or proprietary information of DFH or DFH’s Affiliates, including, but not
        limited to, specifications, samples, formulas, recipes, designs, plans, documents, data,
        business operations, customer lists, pricing, discounts or rebates, disclosed by DFH or
        DFH’s Affiliates to Customer, whether disclosed orally or disclosed or accessed in written,
        electronic or other form or media, and whether or not marked, designated or otherwise
        identified as “confidential,” in connection with this Agreement is confidential, solely for
        the use of performing this Agreement and may not be used, disclosed or copied unless
        authorized by DFH in writing. Upon DFH’s request, Customer shall promptly return all
        documents and other materials received from DFH or DFH’s Affiliates. DFH shall be entitled
        to injunctive relief for any violation of this Section 6. This Section shall not apply to
        information that is: (a) in the public domain; (b) known to the Customer at the time of
        disclosure supported by reasonable written evidence; (c) rightfully obtained by the Customer
        on a non-confidential basis from a third party; (d) disclosed after obtaining DFH’s written
        consent to such disclosure; or (e) required to be produced by Customer in a legal proceeding
        in a court of competent jurisdiction, provided that Customer must (i) promptly notify DFH of
        the same, (ii) help seek a protective order or other confidentiality measures, and (iii)
        only disclose the required portion(s) of such confidential information.
      </p>
      <p>
        7. <span className="text-underline">Intellectual Property; Licensing</span>.
      </p>
      <p>
        A. <span className="text-italic">Intellectual Property Defined</span>. “
        <strong>Intellectual Property</strong>” means all industrial and other intellectual property
        rights including without limitation patents, Trademarks, copyrights and copyrightable works,
        and trade secrets, whether registered or unregistered.
      </p>
      <p>
        B. <span className="text-italic">Retention of Rights, Goodwill</span>. Except to the extent
        provided in a separate written agreement between the Parties or as otherwise set forth
        herein, DFH, DFH’s Affiliates, or licensors to DFH or DFH’s Affiliates own and retain all
        Intellectual Property rights used to create, that are embodied in, or used in the
        manufacture or labeling of or otherwise relating to the Products (“
        <strong>Non-Customer Intellectual Property</strong>”). Customer acquires no ownership
        interest in or to any Non-Customer Intellectual Property under this Agreement. Customer is
        the owner of and retains all Intellectual Property rights in its private label brand name
        and any Marketing Copy created by Customer or on behalf of Customer and/or Trademarks
        created by Customer or on behalf of Customer by a third party (“
        <strong>Customer Intellectual Property</strong>”). Any and all rights and goodwill in any
        Intellectual Property inures solely to the benefit of the owner of such Intellectual
        Property. Each Party shall use the other Party’s Intellectual Property only in accordance
        with this Agreement.
      </p>
      <p>
        C. <span className="text-italic">Customer’s License to DFH</span>. Customer hereby grants
        DFH and DFH’s Affiliates a non-exclusive, royalty-free, limited license to use Customer
        Intellectual Property solely for the purpose of manufacturing and distributing Products for
        Customer in accordance with this Agreement.
      </p>
      <p>
        8. <span className="text-underline">Representations and Warranties.</span>
      </p>
      <p>
        A. <span className="text-italic">Product Warranty</span>.
      </p>
      <p className="text-indent">
        <p>
          (1) <span className="text-italic">Warranty on Regulated Copy</span>. DFH warrants for a
          period of one (1) year from the date of manufacturing that at the time of delivery the
          Regulated Copy on U.S. and Canadian Product labels complies with the applicable Laws of
          the U.S. and Canada, respectively. This warranty supplements rather than replaces the
          warranties DFH provides in the Terms of Sale, which as so supplemented shall be referred
          to as the “<strong>Product Warranty</strong>” in this Private Label Agreement and the
          Terms of Sale, notwithstanding any narrower definition thereof that may appear in the
          Terms of Sale, which for the avoidance of doubt is hereby superseded.
        </p>
        <p>
          (2) <span className="text-italic">Deadline for Warranty Claims</span>. DFH shall not be
          liable for a breach of the Product Warranty unless Customer gives DFH reasonably detailed
          notice of such breach within the shorter of: (i) five (5) business days after Customer
          discovers or ought to have discovered the non-conformance; or (ii) such applicable
          deadline as may be provided by the Terms of Sale.
        </p>
      </p>
      <p>
        B. <span className="text-italic">Customer’s Representations and Warranties</span>.
      </p>
      <p className="text-indent">
        <p>
          (1) <span className="text-italic">Generally.</span> Customer represents and warrants for
          itself and its employees, agents and independent contractors that: (i) the Products,
          including without limitation their ingredients, formulation, and labels, shall comply with
          all Laws applicable in the Territory; (ii) it shall not make any false or misleading
          representations or claims regarding the Products; (iii) it operates and will continue to
          operate its business, and it shall handle, store, market, distribute and sell the
          Products, in compliance with all applicable Laws; (iv) it will store and transport the
          Products in a manner that ensures the Products’ safety and efficacy; (v) any protocols,
          dosage, prescribing and/or usage instructions for the Products provided by Customer to its
          patients or consumers, including without limitation to combine intake of the Products with
          other Products or other dietary supplements or drug products, are safe and present no
          health or safety hazard to such patients or consumers; (vi) it shall not make any
          representations or warranties regarding the Products or import or sell any Products that
          are prohibited under the Laws in the Territory; (vii) it shall comply with all applicable
          Laws relating to anti-bribery and anti-corruption, including without limitation the U.S.
          Foreign Corrupt Practices Act (collectively, “<strong>Anti-Bribery Laws</strong>”); (viii)
          the person who accepts this Agreement has been duly authorized to do so on behalf of
          Customer by all necessary action on the part of Customer; and (ix) this Agreement
          constitutes the legal, valid and binding obligation of Customer, enforceable against
          Customer in accordance with its terms.
        </p>
        <p>
          (2) <span className="text-italic">Medical Treatment or Advice</span>. Customer represents
          and warrants, for itself and Customer’s employees, agents, and contractors, that unless it
          complies with Section 9.B. below regarding professional liability insurance, it does not
          provide medical treatment, advice, or otherwise make individual recommendations to
          consumers to use the Products in the prevention, treatment, or management of any disease
          or health-related condition.
        </p>
        <p>
          (3) <span className="text-italic">Customer Intellectual Property</span>. Customer
          represents, warrants, and covenants that, in all jurisdictions in which Customer sells
          Products or otherwise conducts business:
        </p>
        <p className="text-indent">
          <p>
            (a) Customer is the sole and exclusive legal and beneficial owner of the entire right,
            title, and interest in and to Customer Intellectual Property;
          </p>
          <p>
            (b) Customer is the record owner of all registered Trademarks constituting Customer
            Intellectual Property, and all such issued registrations are valid, subsisting, and in
            full force and effect;
          </p>
          <p>
            (c) Customer has not and will not grant any liens, security interests, or other
            encumbrances in, to, or under Customer Intellectual Property;
          </p>
          <p>
            (d) The exercise by DFH of the rights and license to Customer Intellectual Property
            granted under this Agreement will not infringe or otherwise conflict with the rights of
            any other person or entity;
          </p>
          <p>
            (e) There is no settled, pending, or threatened litigation, opposition, or other claim
            or proceeding challenging the validity, enforceability, ownership, registration, or use
            of any Customer Intellectual Property; and
          </p>
          <p>
            (f) Customer has not brought or threatened any claim against any third-party alleging
            infringement of Customer Intellectual Property, nor, to its knowledge, is any
            third-party infringing or threatening to infringe on Customer Intellectual Property.
          </p>
        </p>
      </p>
      <p>
        9. <span className="text-underline">Indemnification.</span>
      </p>
      <p>
        A. <span className="text-italic">Indemnification by DFH</span>. DFH shall indemnify, defend
        and hold harmless Customer and its officers, directors, employees, agents, independent
        contractors, Affiliates, successors and permitted assigns (each a “
        <strong>Party Indemnified by DFH</strong>”) against any and all <strong>Losses</strong>{' '}
        (defined in the Terms of Sale) incurred by a Party Indemnified by DFH directly as a result
        of any <strong>Claim</strong> (defined in the Terms of Sale) to the extent arising out of:
        (i) any claim of personal injury or property damage made by a third party as a result of
        using or consuming the Products in accordance with labeled instructions, except to the
        extent such personal injury or property damage is caused by Customer’s failure to comply
        with the terms of this Agreement or is due to Customer’s or its employees, agents or
        independent contractor’s negligent or more culpable act or omission; and/or (ii) any claim
        of a third party that Non-Customer Intellectual Property that is owned by DFH or one of
        DFH’s Affiliates infringes or otherwise misappropriates any Intellectual Property right of
        such third party.
      </p>
      <p>
        B. <span className="text-italic">Indemnification by Customer</span>. Customer shall
        indemnify, defend and hold harmless the <strong>Parties Indemnified by Customer</strong>{' '}
        (defined in the Terms of Sale) against any and all Losses incurred by a Party Indemnified by
        Customer directly as a result of any Claim to the extent arising out of: (i) Marketing Copy
        and Marketing Materials; (ii) sales of Products by Customer or any person on Customer’s
        behalf outside of the Territory; (iii) any claim of a third party that Customer Intellectual
        Property, including without limitation Customer’s Trademarks, infringes or otherwise
        misappropriates any Intellectual Property right of such third party; (iv) each breach by
        Customer of Customer’s covenants, representations, or warranties in this Agreement; and/or
        (v) anything listed in the Terms of Sale as triggering a duty of Customer to indemnify,
        defend, or hold harmless a Party Indemnified by Customer.
      </p>
      <p>
        C. <span className="text-italic">Control of Claims</span>. The Party that is indemnifying,
        defending, or holding harmless the other Party (“
        <strong>Indemnifying Party</strong>” and “<strong>Indemnified Party</strong>,” respectively)
        shall have the right to control the defense of any Claim.
      </p>
      <p>
        10. <span className="text-underline">Insurance.</span>
      </p>
      <p>
        A. <span className="text-italic">Insurance Obligation of DFH</span>. During the term of this
        Agreement and for one (1) year thereafter, DFH shall, at its own expense, maintain and carry
        commercial general and products liability insurance in a sum no less than One Million US
        Dollars (US $1,000,000) per occurrence and Two Million US Dollars (US $2,000,000) in the
        aggregate with financially sound and reputable insurers or a reasonably comparable amount in
        Canadian Dollars. Upon a Customer’s request, DFH shall provide Customer with a certificate
        of insurance from DFH’s insurer evidencing the insurance coverage specified in this
        Agreement. DFH shall provide Customer with at least thirty (30) days’ prior written notice
        in the event of a cancellation or material change in the insurance policies required
        hereunder.
      </p>
      <p>
        B. <span className="text-italic">Insurance Obligation of Customer</span>. If Customer or
        Customer’s employees, agents, or contractors provide medical treatment, advice, or otherwise
        make individual recommendations to consumers to use the Products in the prevention,
        treatment, or management of any disease or health-related condition, or if required by DFH
        in its absolute discretion and communicated to Customer before the Effective Date or on
        reasonable prior notice, then Customer shall, at its own expense, maintain and carry
        malpractice/professional liability insurance coverage with a minimum aggregate coverage
        limit of One Million US Dollars (US $1,000,000) per occurrence with a Two Million US Dollars
        (US $2,000,000) annual aggregate limit, and upon DFH’s request, Customer shall promptly
        provide DFH with a certificate of insurance from Customer’s insurer evidencing the insurance
        coverage specified herein and listing all practitioners by name covered by such policy.
      </p>
      <p>
        11. <span className="text-underline">Private Label Accounts for Business Entities. </span>
      </p>
      <p>
        A. <span className="text-italic">Unapproved Conversion to a Business Entity Account</span>.
      </p>
      <p className="text-indent">
        <p>
          (1) <span className="text-italic">Unapproved Conversion, Defined.</span> Customer shall be
          deemed to have converted Customer’s Private Label Account to an unapproved business entity
          account (“<strong>Unapproved Conversion</strong>”) if, despite Customer’s warranty above
          that Customer entered into this Agreement in Customer’s individual capacity as a natural
          person, each of the three subsections (a) through (c) below is true:
        </p>
        <p className="text-indent">
          <p>
            (a) on or after the Effective Date, a business entity of which Customer is an agent, or
            on behalf of which Customer otherwise acts on any matter with actual or apparent
            authority, whether as the business entity’s director, officer, executive, employee,
            agent, principal, or in any other capacity (“
            <strong>Customer’s Business Entity</strong>”), (i) effects a change to DFH’s records as
            to the name, address, or other such details associated with Customer’s Account, (ii)
            purports to or does place Orders for, accept invoices for, pay for, accept deliveries
            of, make returns of, or submit breach-of-warranty claims for Products, or (iii) asserts
            orally or in writing that Customer’s Business Entity is the Private Label Account holder
            or the counterparty of DFH with respect to this Agreement; or (iii) otherwise transacts
            or engages with DFH in a manner that uses or affects Customer’s Private Label Account,
            and
          </p>
          <p>
            (b) During any time when subsection 11.A.(1).(a) above was satisfied, there was not
            already, as between Customer’s Business Entity and DFH, (i) a Private Label
            Account—distinct from Customer’s account—of which Customer’s Business Entity was the
            Account holder; or (ii) an agreement titled “Private Label Agreement” or otherwise
            covering the topics addressed by this Agreement with approximately the same degree of
            comprehensiveness as this Agreement; and
          </p>
          <p>
            (c) DFH accepts, fulfills, or causes the acceptance or fulfillment of Orders placed
            through the Account, or otherwise engages with the Account.
          </p>
        </p>
        <p>
          (2) <span className="text-italic">Lack of Knowledge.</span> For the avoidance of doubt, to
          the maximum extent permitted by applicable Law, Customer may be deemed to create an
          Unapproved Business Entity Account pursuant to this Section 11.A.(1) regardless of whether
          or when either Party is aware that this has occurred.
        </p>
      </p>
      <p>
        B. <span className="text-italic">Approved Conversion</span>.
      </p>
      <p className="text-indent">
        <p>
          (1) <span className="text-italic">Approved Conversion, Defined.</span> Customer shall be
          deemed to have converted Customer’s Account to an approved business entity account (“
          <strong>Approved Conversion</strong>”) if Customer’s Business Entity and DFH expressly
          agree to the Approved Conversion in a signed writing, or if each of the four subsections
          (a) through (d) below is otherwise true:
        </p>
        <p className="text-indent">
          <p>
            (a) Customer (i) requests that Customer’s Private Label Account be held by Customers’
            Business Entity rather than Customer, or (ii) requests that DFH transact with Customer
            only in Customer’s capacity as an agent of Customer’s Business Entity rather than in
            Customer’s individual capacity as a natural person, or (iii) requests that Customer’s
            Business Entity rather than Customer be the counterparty to DFH with respect to this
            Agreement; and
          </p>
          <p>
            (b) DFH, it its sole discretion, determines that Customer’s Business Entity was validly
            formed in its jurisdiction of registration, is authorized to conduct business of the
            nature contemplated by this Private Label Agreement, and is in good standing in its
            jurisdiction of registration and in all jurisdictions in which it is authorized to do
            business; and
          </p>
          <p>(c) such determination is factually correct; and</p>
          <p>
            (d) at all times, the process and means by which Customer’s request is submitted,
            processed, internally approved by DFH, and communicated to Customer or Customer’s
            Business Entity materially complies with DFH’s standard operating procedures and met all
            DFH’s requirements regarding the same (collectively, the “
            <strong>Approved Conversion Process</strong>”), as determined by DFH in its absolute
            discretion.
          </p>
        </p>
        <p>
          (2) <span className="text-italic">Approved Conversion Process.</span> DFH may determine
          all details of the Approved Conversion Process and revise the same from time to time, with
          or without prior notice to Customer, in DFH’s absolute discretion. Compliance with the
          Approved Conversion Process may require Customer to agree to additional terms and
          conditions, which DFH may determine in its absolute discretion. DFH, upon reasonable
          written request, shall make available to Customer all relevant details regarding how
          Customer may comply with the Approved Conversion Process, to the extent Customer needs to
          know such details in order to comply with it.
        </p>
      </p>
      <p>
        C. <span className="text-italic">Consequences of Conversion</span>. This Section 11.C. sets
        forth consequences of Unapproved Conversion, Approved Conversion (collectively, “
        <strong>Conversion</strong>”), or both, except to the extent otherwise provided in a writing
        signed by DFH, Customer, and Customer’s Business Entity, including without limitation an
        assignment and assumption agreement. The consequences of Conversion that are set forth below
        are effective retroactively as of the latest of the following dates: (1) the date Customer’s
        Business Entity was formed; (2) the most recent date Customer’s Business Entity regained the
        capacity to enter into a binding contract after having lost such capacity (if applicable);
        and (3) the Effective Date of this Agreement. Notwithstanding anything in this Agreement to
        the contrary, the retroactive effect of this Section 11.C. shall not make a retroactive
        breach out of any act, omission, or status of DFH that was not a breach when it happened.
      </p>
      <p className="text-indent">
        <p>
          (1) <span className="text-italic">Consequences of Conversion, Generally</span>. Approved
          Conversion or Unapproved Conversion (collectively, “<strong>Conversion</strong>”), to the
          maximum extent permitted by applicable Law, shall have the following effects: (i) Customer
          and Customer’s Business Entity shall be treated as Affiliates of one another; (ii) the
          liability of each such Affiliate with respect to the other such Affiliate, as provided for
          in the Terms of Sale, shall be joint and several; (iii) Customer’s Business Entity, by
          taking one or more of the actions listed in Section 11.A.(1).(a), enters into this
          Agreement as an additional Party; and (iv) for the avoidance of doubt, a notice from DFH
          to Customer shall satisfy any requirement to provide such notice to Customer’s Business
          Entity, and a notice from DFH to Customer’s Business Entity shall satisfy any requirement
          to provide such notice to the Customer, regardless of to which of the two the notice is
          addressed or directed.
        </p>
        <p>
          (2) <span className="text-italic">Consequences of Unapproved Conversion.</span> In the
          event of an Unapproved Conversion, to the maximum extent permitted by applicable Law, the
          following consequences apply in addition to those stated in Section 11.(C).(1) above:
        </p>
        <p className="text-indent">
          <p>
            (a) DFH may discharge any one or more of its obligations under this Agreement by
            rendering performance to Customer or to Customer’s Business Entity, and DFH, in DFH’s
            absolute discretion, may select which of the two to which to render such performance,
            with or without prior notice to Customer or Customer’s Business Entity;
          </p>
          <p>
            (b) Customer’s Business Entity shall not—and Customer and Customer’s Business Entity
            hereby waive the latter’s right, if any, to—have, enjoy, accrue, be entitled to, or
            otherwise benefit because of rights under, arising from, or related to this Agreement,
            including without limitation the right to (i) receive delivery of Orders DFH has
            accepted if Customer has no outstanding balance with DFH, (ii) initiate or join a
            lawsuit alleging DFH breached this Agreement, and (iii) seek or receive indemnification
            or defense from DFH or any DFH Entity; and
          </p>
          <p>
            (c) If for any reason after Conversion, despite Section 11.C.(1) above, Customer’s
            Business Entity is not a party or ceases to be a party to this Agreement, then, for the
            avoidance of doubt, Customer’s Business Entity shall not be a third-party beneficiary of
            this Agreement.
          </p>
        </p>
        <p>
          (3) <span className="text-italic">Consequences of Approved Conversion</span>. In the event
          of an Unapproved Conversion, to the maximum extent permitted by applicable Law, the
          following consequences apply in addition to those stated in Section 11.(C).(1) above:
        </p>
        <p className="text-indent">
          <p>
            (a) DFH shall discharge its obligations under this Agreement by rendering performance to
            Customer’s Business Entity rather than to Customer in his or her individual capacity as
            a natural person;
          </p>
          <p>
            (b) Customer’s Business Entity, and not Customer in his or her individual capacity as a
            natural person, shall render all performance, and discharge all duties, due from
            Customer that are required by, arise from, or relate to this Agreement, including
            without limitation the obligation to pay for accepted Orders, maintain insurance, and
            indemnify, defend, and hold harmless the Parties Indemnified by Customer, to the same
            extent as if the term “Customer” in this Agreement (other than in this Section 11) were
            replaced with the term “Customer’s Business Entity”;
          </p>
          <p>
            (c) All rights or other benefits that Customer may in the past, present, or future
            exercise, have, enjoy, or accrue, or to which Customer otherwise was, is, or becomes
            entitled to, to the extent such rights or benefits are pursuant to, arising from, or
            related to this Agreement—including without limitation and for example the right to
            receive delivery of accepted Orders of Products for which DFH has been fully paid
            pursuant to this Agreement—can and shall be exercised and enjoyed only by Customer’s
            Business Entity and not by Customer, and Customer otherwise irrevocably waives such
            rights and benefits.
          </p>
          <p>
            (d) If for any reason after Conversion, despite Section 11.C.(1) above, Customer’s
            Business Entity is not a party or ceases to be a party to this Agreement, then, for the
            avoidance of doubt, Customer’s Business Entity shall be a third-party beneficiary of
            this Agreement.
          </p>
        </p>
      </p>
      <p>
        D. <span className="text-italic">Customer’s Privacy Warranty regarding Conversion</span>.
      </p>
      <p className="text-indent">
        <p>
          (1) <span className="text-italic">Nature of this Warranty, Definitions</span>. This
          Section 11.D. relates to: (i) the California Consumer Privacy Act of 2018, Civil Code
          section 1798.100 et seq., as amended by the California Privacy Rights Act of 2020 and the
          regulations promulgated under the Acts (collectively, “<strong>CCPA</strong>”); (ii) the
          Health Insurance Portability and Accountability Act of 1996 (Public Law 104-191), the
          Health Information Technology for Economic and Clinical Health Act (Public Law 111-5), and
          their implementing regulations (collectively, “<strong>HIPAA</strong>”); and (iii) all
          other applicable Laws (collectively with HIPAA and the CCPA, “
          <strong>Data Privacy Laws</strong>”) that protect, restrict, or otherwise govern the
          manual or automatic creation, collection, procurement, obtainment, access, recording,
          viewing, reviewing, organization, storage, adaptation, alteration, retrieval,
          consultation, use, transmission, disclosure, sale, sharing, erasure, deletion, or
          destruction (collectively, “<strong>Processing</strong>”) of “
          <strong>Personal Information</strong>” (defined by the CCPA), “
          <strong>Protected Health Information</strong>” (defined by HIPAA), or of any other
          personal data or information, including without limitation personally identifiable
          information (all such information, collectively, “<strong>PI</strong>”) about one or more
          third parties (each a “<strong>Data Subject</strong>” to the extent his or her PI is
          protected by a Data Privacy Law), including without limitation retail customers of
          Customer or DFH.
        </p>
        <p>
          (2) <span className="text-italic">Customer’s Privacy Warranty regarding Conversion.</span>{' '}
          To the extent Customer’s Business Entity Processes the PI of any Data Subject, including
          without limitation by accessing, making purchases through, or otherwise using Customer’s
          Account, and to the extent that such Processing is caused, made possible, enabled, or
          otherwise effectuated by Conversion, then Customer and Customer’s Business Entity each
          make a continuing representation, warranty, and covenant that:
        </p>
        <p className="text-indent">
          <p>
            (a) Each such Data Subject has given informed consent, and received proper notice, of:
            (i) the Conversion; and (ii) the Processing of such Data Subject’s PI by Customer’s
            Business Entity, in each case in accordance with the posted privacy notice(s)/polic(ies)
            of Customer and Customer’s Business Entity;
          </p>
          <p>
            (b) The informed consent and notice referenced in the subsection above (Section
            11.D.(2)(a)) fully satisfy, and do not violate, the requirements of all Data Privacy
            Laws and other Laws, including for example and without limitation requirements as to
            timing, content, and presentation;
          </p>
          <p>
            (c) To the extent required by all Data Privacy Laws and other Laws, no such Data Subject
            has withdrawn the consent referenced above in Section 11.D.(2).(a) or opted out of the
            sale, sharing, or other Processing of his or her PI by Customer or Customer’s Business
            Entity (as those terms are defined in the CCPA);
          </p>
          <p>
            (d) DFH’s past, present, and future performance under this Agreement, and Customer’s
            Business Entity’s past, present, and future Processing of such Data Subjects’ PI has
            not, does not, and will not violate any: (i) Data Privacy Law or other Law, (ii) privacy
            polic(ies) or privacy notice(s) of Customer, Customer’s Business Entity, or any third
            party, or (ii) any agreement between or among such Data Subject and Customer or
            Customer’s Business Entity; and
          </p>
          <p>
            (e) Neither Customer nor Customer’s Business is a “<strong>business</strong>,” and DFH
            is not the “<strong>service provider</strong>” or “<strong>contractor</strong>” of
            Customer or Customer’s Business Entity, as those terms are defined in the CCPA, unless
            Customer’s Business Entity and DFH, as of the Effective Date, are parties to a written
            agreement titled “Data Processing Addendum” and governing the Processing referenced in
            Section 11.D.(2);
          </p>
          <p>
            (f) Neither Customer nor Customer’s Business is a “<strong>covered entity</strong>
            ,” and DFH is not Customer or Customer’s Business’s “<strong>business associate</strong>
            ,” as those terms are defined in HIPAA, unless Customer’s Business Entity and DFH, as of
            the Effective Date, are parties to a written agreement titled “Business Associate
            Agreement” and governing the Processing referenced in Section 11.D.(2); and
          </p>
          <p>
            (g) Neither Customer nor Customer’s Business is subject to any Data Privacy other than
            the CCPA or HIPAA, except to the extent Customer or Customer’s Business Entity expressly
            notified DFH otherwise before Conversion, and DFH expressly approved the matter, and
            such Conversion was an Approved Conversion.
          </p>
        </p>
      </p>
      <p>
        12. <span className="text-underline">Miscellaneous.</span>
      </p>
      <p>
        A. <span className="text-italic">Recalls</span>. DFH in its absolute discretion shall
        determine whether to recall or withdraw any Product at any time. If DFH notifies Customer of
        a recall or withdrawal of a Product, then Customer—only to the extent directed to do so by
        DFH, and strictly in the manner directed by DFH, in DFH’s absolute discretion—shall promptly
        notify all customers to whom or to which it shipped such recalled or withdrawn Product and
        coordinate the return or destruction of all such recalled or withdrawn Products, as well as
        the return to DFH or destruction of any recalled or withdrawn Products still in
        Distributor’s possession. Distributor shall document, in writing and in the ordinary course
        of its business operations, all reasonable costs and expenses incurred by Distributor in
        connection with each Product recall and withdrawal, excluding Distributor’s overhead costs
        or other fixed costs. Distributor shall expressly identify each such cost and expense as
        being connected to such recall or withdrawal. All recalls of Products shall be handled by
        the Parties in accordance with applicable Laws, including without limitation Laws regarding
        “adverse event” reporting. For the avoidance of doubt: (i) DFH may recall or withdraw a
        Product even if there is no past or current breach of the Product Warranty associated in any
        way with such recall or withdrawal; and (ii) the fact of such a recall or withdrawal shall
        not, without more, constitute a breach of the Product Warranty or other breach of this
        Agreement.
      </p>
      <p>
        B. <span className="text-italic">Survival</span>. The sections titled as follows, along with
        their subsections and all other subordinate elements thereof, survive the termination or
        expiration of this Agreement: Confidential Information; Intellectual Property, Licensing;
        Indemnification; Limitation of Liability; and Miscellaneous.
      </p>
      <p>
        C. <span className="text-italic">Waiver of Jury Trial</span>. EACH PARTY ACKNOWLEDGES AND
        AGREES THAT ANY CONTROVERSY THAT MAY ARISE UNDER THIS AGREEMENT IS LIKELY TO INVOLVE
        COMPLICATED AND DIFFICULT ISSUES AND, THEREFORE, EACH SUCH PARTY IRREVOCABLY AND
        UNCONDITIONALLY WAIVES ANY RIGHT IT MAY HAVE TO A TRIAL BY JURY IN RESPECT OF ANY LEGAL
        ACTION ARISING OUT OF OR RELATING TO THIS AGREEMENT OR THE TRANSACTIONS CONTEMPLATED HEREBY.
      </p>
      <p>
        D. <span className="text-italic">Notice</span>. The “Notice” section of the Terms of Sale
        applies to this Agreement, except that: (i) notice from Customer to DFH solely by email does
        not qualify as notice; and (ii) in addition to the addresses and email addresses to which
        DFH, pursuant to the Terms of Sale, may provide notice to Customer, DFH may also send notice
        to Customer at the address(es) and/or email address(es) for Customer that are set forth in
        the latest “Distributed By” Information that Customer has provided to DFH.
      </p>
      <p>
        E. <span className="text-italic">Entire Agreement</span>. This Agreement constitutes the
        entire agreement between the Parties with respect to the subject matter hereof and
        supersedes any prior oral or written agreements between the Parties, including any previous
        Private Label Agreement between the Parties, except to the extent the Parties, before the
        Effective Date, entered into a written signed agreement that expressly stated it shall
        prevail over future agreements that may be formed between the Parties titled “Private Label
        Agreement” or otherwise covering the subject matter of this Agreement.
      </p>
      <p>
        F. <span className="text-italic">Amendments; No Waiver</span>. For the avoidance of doubt,
        no part of this Agreement may be amended or waived except as provided the Terms of Sale.
      </p>
      <p>
        G. <span className="text-italic">No Exclusivity</span>. No relationship of exclusivity shall
        be construed from this Agreement.
      </p>
      <p>
        H. <span className="text-italic">Consent to Use of the English Language</span>. “DFH et toi
        ont convenu que le present contrat serait rédigé en la langue anglaise.” That means, “DFH
        and you have agreed that the present contract be drafted in the English language.”
      </p>
    </Styled.ContentContainer>
  )
}

PLAgreementOct022023Content.documentKey = legalAgreementIds.plOct022023

const StyledPLAgreementOct022023Content = styled(PLAgreementOct022023Content)``

export default StyledPLAgreementOct022023Content
